<app-dialog-base [Title]='"Photo"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroupwithimage">
    <label>{{'Photo'|translate}}</label>
    <image-upload #image
      [uploaded]="model.Id ? ['/ctrl/objects/photos/photo/' + this.model.Id] : []">
    </image-upload>
  </div>
  <div class="inputgroup">
    <label>{{'Description'|translate}}</label>
    <input type="text" [(ngModel)]="model.Name" />
  </div>
</app-dialog-base>
